import React from 'react';
import { Dropdown } from '@insurancemenu/imenu-components-lib';
import { DropdownOptionType, OptionsAlignmentTypes } from '@insurancemenu/imenu-components-lib/dist/types/Dropdown';
import { ChevronDown, Delete, Download } from '@insurancemenu/imenu-components-lib/dist/icons';
import { downloadByUrl } from '@insurancemenu/imenu-components-lib/dist/helpers/downloadByUrl';
import { removeInitialSeed } from 'api/operations/productServiceV2';
import { observer } from 'mobx-react-lite';
import { useInitialSeedProductTemplatesStore } from 'store/pages/rfq/rfq-template/initial-seed-product-templates/pageStore';
import { DropdownButtonStyled } from './styles';

interface Props {
  clientGroupId: string;
  jsonLink: string;
}

const MoreDropdown: React.FC<Props> = observer(({ clientGroupId, jsonLink }) => {
  const { getInitialData, setIsLoading } = useInitialSeedProductTemplatesStore();

  const downloadProductTemplateOption: DropdownOptionType = {
    value: 'downloadProductTemplate',
    label: 'Download Template',
    icon: Download,
    onOptionClick: (): void => {
      downloadByUrl(jsonLink);
    },
  };

  const removeProductTemplateOption: DropdownOptionType = {
    value: 'removeProductTemplate',
    label: 'Remove Template',
    icon: Delete,
    customColor: 'red',
    onOptionClick: async (): Promise<void> => {
      setIsLoading(true);
      await removeInitialSeed(clientGroupId);
      await getInitialData();
    },
  };

  function getOptions(): DropdownOptionType[] {
    const resultOptions = [removeProductTemplateOption];
    if (jsonLink) {
      resultOptions.unshift(downloadProductTemplateOption);
    }
    return resultOptions;
  }

  return (
    <Dropdown
      name="More"
      options={getOptions()}
      optionsAlignment={OptionsAlignmentTypes.BOTTOM_LEFT}
      optionsWidth="25rem"
      closedElement={
        <DropdownButtonStyled $isClosed color="primary" type="text" rightIconProp={<ChevronDown />}>
          MORE
        </DropdownButtonStyled>
      }
      openedElement={
        <DropdownButtonStyled $isClosed={false} color="primary" rightIconProp={<ChevronDown />}>
          More
        </DropdownButtonStyled>
      }
    />
  );
});

export default MoreDropdown;
